import React from 'react';
import { nodeTabClass } from '../railClasses';
import { RailPage } from './contentPages';
import { useRailLink } from './RailLink';

interface NodeTabsProps {
  label?: string;
  pages: RailPage[];
  tabClass?: (active: boolean) => string;
}

// A node's pages as a tab row. Links come from the RailLink context, so the legacy bar renders
// anchors and the SPA renders router links, with the same active and meta treatment.
const NodeTabs = ({ label = 'Pages', pages, tabClass = nodeTabClass }: NodeTabsProps) => {
  const RailLink = useRailLink();

  return (
    <nav aria-label={label} className="tw-flex tw-flex-wrap tw-gap-0.5">
      {pages.map(page => (
        <RailLink key={page.label} className={tabClass} page={page}>
          {page.label}
          {page.meta && <span className="tw-text-xs tw-font-normal tw-opacity-70">{page.meta}</span>}
        </RailLink>
      ))}
    </nav>
  );
};

export default NodeTabs;
